import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AppButton from '../../styles/common/AppButton';
import btnClose from '../../images/common/close.svg';
import boardImage from '../../images/common/board.svg';
import callImage from '../../images/common/call_white_24dp.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

const RemoteMembersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const RemoteMember = styled.div`
  margin: 2px;
  width: 94px;
  height: 24px;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.bgColor || ColorSF2.lightGray};
  border-radius: 10px;
  font-size: 12px;
`;
const MemberName = styled.div`
  width: 70px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
`;
const CloseButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CloseButtonImage = styled.img`
  width: 8px;
  height: 8px;
`;
const AllClearButton = styled(RemoteMember)`
  padding-left: 0px;
  background-color: unset;
  border: 1px solid ${ColorSF2.twilightBlue};
  justify-content: center;
  color: ${ColorSF2.twilightBlue};
`;
const RemoteActionButtons = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonImage = styled.img`
  margin-right: 4px;
  margin-bottom: 1px;
  height: 14px;
  display: flex;
  align-items: center;
`;

const ContactActions = ({
  remoteMembers,
  openBlackboardList,
  toggleCheckbox,
  resetCheckbox,
  remoteUrl,
}) => {
  const noChecked = remoteMembers.length === 0;
  return (
    <Fragment key="operator-remote-actions">
      <RemoteMembersWrapper>
        {!noChecked && (
          <Fragment key="RemoteMembersWrapper">
            {remoteMembers.map(({ operatorId, name }) => (
              <RemoteMember key={`remote-member-${operatorId}`}>
                <MemberName>{name}</MemberName>
                <CloseButton
                  id={`DeleteRemoteMember-${operatorId}`}
                  role="presentation"
                  className="button"
                  onClick={() => toggleCheckbox(operatorId)}
                >
                  <CloseButtonImage src={btnClose} alt="close" />
                </CloseButton>
              </RemoteMember>
            ))}
            <AllClearButton className="button" onClick={resetCheckbox}>
              <FormattedMessage id="operator.dashboard.remote.clear" />
            </AllClearButton>
          </Fragment>
        )}
      </RemoteMembersWrapper>
      <RemoteActionButtons>
        <AppButton
          small
          borderColor={ColorSF2.navyBlue}
          bgColor="undefined"
          color={ColorSF2.navyBlue}
          disabled={noChecked}
          className={!noChecked && 'button'}
          onClick={!noChecked ? openBlackboardList : undefined}
        >
          <ButtonImage src={boardImage} alt="board" />
          <FormattedMessage id="operator.dashboard.remote.blackboard" />
        </AppButton>
        {(noChecked && (
          <AppButton disabled small>
            <ButtonImage src={callImage} alt="call" />
            <FormattedMessage id="operator.dashboard.remote.call" />
          </AppButton>
        )) || (
          <Link target="_blank" to={remoteUrl}>
            <AppButton className="button" small onClick={resetCheckbox}>
              <ButtonImage src={callImage} alt="call" />
              <FormattedMessage id="operator.dashboard.remote.call" />
            </AppButton>
          </Link>
        )}
      </RemoteActionButtons>
    </Fragment>
  );
};

ContactActions.propTypes = {
  remoteMembers: PropTypes.array.isRequired,
  openBlackboardList: PropTypes.func.isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
  resetCheckbox: PropTypes.func.isRequired,
  remoteUrl: PropTypes.string.isRequired,
};

export default ContactActions;
